import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import {
  PotentialAppointmentListModel,
  PotentialAppointmentSlot,
} from "../../widget.model";
import * as moment from "moment";

@Component({
  selector: "appointment-slots",
  templateUrl: "./appointment-slots.component.html",
})
export class AppointmentSlotsComponent implements OnInit, OnChanges {
  @Input() potentialAppointmentList: PotentialAppointmentListModel[];
  @Input() selectedDateFromDatepicker: any;
  @Output() getMorePotentialAppointments = new EventEmitter();
  @Output() selectedSlot = new EventEmitter();

  selected: PotentialAppointmentSlot;
  slotExists: boolean = false;
  slotsShown: number = 4;
  numberOfDays: number;
  moreSlotsExist: boolean;

  constructor() {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.potentialAppointmentList &&
      changes.potentialAppointmentList.currentValue
    ) {
      this.slotsShown = 4;
      this.slotExists = false;
      this.moreSlotsExist = false;
      this.numberOfDays = changes.potentialAppointmentList.currentValue.length;
      this.potentialAppointmentList.forEach((item) => {
        item.date = moment(item.date).format("YYYY-MM-DD");
        if (item.potentialAppointments.length != 0) {
          this.slotExists = true;
        }
        if (!this.moreSlotsExist) {
          if (item.potentialAppointments.length > 4) {
            this.moreSlotsExist = true;
          }
        }
      });
    }
    if (
      changes.selectedDateFromDatepicker &&
      changes.selectedDateFromDatepicker.currentValue
    ) {
      this.selectedDateFromDatepicker = moment(
        this.selectedDateFromDatepicker
      ).format("YYYY-MM-DD");
    }
  }

  changeNumberOfSlots() {
    if (this.slotsShown === 4) {
      this.slotsShown = Number.MAX_SAFE_INTEGER;
    } else {
      this.slotsShown = 4;
    }
  }

  getMoreSlots(str: string) {
    this.getMorePotentialAppointments.next(str);
  }

  selectSlot(slot: PotentialAppointmentSlot) {
    this.selected = slot;
    this.selectedSlot.next(slot);
  }
}



// WEBPACK FOOTER //
// C:/Users/strahinja.aparac/Desktop/git/source/healthcare/v2/app/appointment-widget/src/app/components/appointment-slots/appointment-slots.component.ts